function initRefreshment(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'loading';
  const config = JSON.parse(root.querySelector('[data-rfs-config]').textContent);
  const decoder = document.createElement('textarea');
  const labels = Object.fromEntries(Object.entries(config.labels).map(([key, value]) => {
    decoder.innerHTML = value;
    return [key, decoder.value];
  }));
  const tx = key => labels[key] ?? key;
  const q = selector => root.querySelector(selector);
  const money = value => 'A$' + value.toLocaleString('en-AU', { minimumFractionDigits: Number.isInteger(value) ? 0 : 2, maximumFractionDigits: 2 });
  const panel = q('[data-rfs-panel]'), scroll = q('[data-rfs-scroll]'), opener = q('[data-rfs-open]');
  let returnFocus = opener;
  const sourceScope = config.sourceId !== config.stationId ? document.querySelector('.product-information') : null;
  const drinks = [
    { name: 'Mango Jasmine', description: tx('drink_note_mango'), image: config.images[0], qty: 0, garnishes: ['Dehydrated lime wheel', 'Dehydrated mango strip', 'Citrus-infused sugar rim'] },
    { name: 'Butterfly Lychee Bloom', description: tx('drink_note_butterfly'), image: config.images[1], qty: 0, garnishes: ['Dried lime ring'] },
    { name: 'Pomegranate Lychee', description: tx('drink_note_pomegranate'), image: config.images[2], qty: 0, garnishes: ['Dehydrated lime wheel', 'Pomegranate seeds', 'Crushed berry rim'] }
  ];
  let mode = null, matched = true, currentStage = 'choice', busy = false;
  let linkedExperience = { title: '', guests: null }, cartSnapshot = null, pageLock = null;
  let viewportFrame = 0, viewportHeightAtOpen = 0, editingStation = null;
  let pendingSubmission = null, copiedStation = null;
  let deferredMode = false, editingDraftId = null;
  const drafts = [];
  const sourceOwner = () => sourceScope?.querySelector('.buy-buttons-block product-form-component');
  const sourceService = () => copiedStation ? null : window.OlouiooService?.read(sourceOwner());
  const reviewTitle = q('[data-rfs-review-title]')?.textContent;
  const reviewNote = q('[data-rfs-review-note]')?.textContent;

  function revealControl(control) {
    if (!panel.open || !scroll.contains(control)) return;
    const field = control.getBoundingClientRect(), area = scroll.getBoundingClientRect();
    if (area.bottom <= area.top) return;
    if (field.bottom > area.bottom - 12) scroll.scrollTop += field.bottom - area.bottom + 12;
    else if (field.top < area.top + 12) scroll.scrollTop -= area.top - field.top + 12;
  }
  function keepFieldVisible() {
    const active = document.activeElement;
    if (scroll.contains(active) && active.matches('input,select,textarea')) revealControl(active);
  }
  function syncViewport() {
    viewportFrame = 0;
    if (!panel.open) return;
    const viewport = window.visualViewport;
    if (viewport && Math.abs(viewport.scale - 1) > .01) return;
    const height = viewport?.height || window.innerHeight;
    viewportHeightAtOpen = Math.max(viewportHeightAtOpen, height);
    panel.style.setProperty('--rfs-viewport-height', height + 'px');
    panel.style.setProperty('--rfs-viewport-top', Math.max(0, viewport?.offsetTop || 0) + 'px');
    const active = document.activeElement;
    const editing = panel.contains(active) && active.matches('input:not([type="hidden"]),textarea,select');
    panel.dataset.keyboardOpen = String(editing && viewportHeightAtOpen - height > 120);
    keepFieldVisible();
  }
  function queueViewport() {
    if (panel.open && !viewportFrame) viewportFrame = requestAnimationFrame(syncViewport);
  }
  function watchViewport() {
    viewportHeightAtOpen = window.visualViewport?.height || window.innerHeight;
    window.visualViewport?.addEventListener('resize', queueViewport);
    window.visualViewport?.addEventListener('scroll', queueViewport);
    window.addEventListener('resize', queueViewport);
    queueViewport();
  }
  function releaseViewport() {
    window.visualViewport?.removeEventListener('resize', queueViewport);
    window.visualViewport?.removeEventListener('scroll', queueViewport);
    window.removeEventListener('resize', queueViewport);
    cancelAnimationFrame(viewportFrame);
    viewportFrame = 0;
    panel.style.removeProperty('--rfs-viewport-height');
    panel.style.removeProperty('--rfs-viewport-top');
    delete panel.dataset.keyboardOpen;
  }
  panel.addEventListener('focusin', queueViewport);
  panel.addEventListener('focusout', queueViewport);

  function openPanel(edit = null, trigger = opener, copy = null, draft = null) {
    if (panel.open) return;
    returnFocus = trigger;
    deferredMode = Boolean(draft);
    editingDraftId = draft?.id || null;
    panel.toggleAttribute('data-rfs-deferred', deferredMode);
    editingStation = edit;
    copiedStation = copy;
    currentStage = 'choice';
    drinks.forEach(drink => {
      drink.qty = 0;
      drink.row.querySelector('.rr-counter input').value = 0;
    });
    if (draft?.state) { restoreDraftState(draft.state); }
    else if (edit || copy) {
      restoreStation(edit || copy);
      if (copy) q('.rfs-panel-header h2').textContent = tx('add_another');
    }
    else { matched = true; q('.rfs-panel-header h2').textContent = defaultPanelTitle; refreshConnection(); syncSourceDefaults(); }
    update();
    pageLock = { y: window.scrollY, htmlOverflow: document.documentElement.style.overflow, bodyOverflow: document.body.style.overflow, position: document.body.style.position, top: document.body.style.top, width: document.body.style.width };
    document.documentElement.dataset.rfsPanelOpen = 'true';
    document.documentElement.style.overflow = 'hidden';
    Object.assign(document.body.style, { overflow: 'hidden', position: 'fixed', top: -pageLock.y + 'px', width: '100%' });
    panel.showModal();
    opener.setAttribute('aria-expanded', 'true');
    returnFocus.setAttribute('aria-expanded', 'true');
    focusStage();
    watchViewport();
  }
  function restorePage() {
    releaseViewport();
    opener.setAttribute('aria-expanded', 'false');
    returnFocus.setAttribute('aria-expanded', 'false');
    if (!pageLock) return;
    const saved = pageLock;
    pageLock = null;
    delete document.documentElement.dataset.rfsPanelOpen;
    document.documentElement.style.overflow = saved.htmlOverflow;
    Object.assign(document.body.style, { overflow: saved.bodyOverflow, position: saved.position, top: saved.top, width: saved.width });
    window.scrollTo({ top: saved.y, left: 0, behavior: 'instant' });
  }
  function closePanel(restoreFocus = true) {
    const edit = editingStation || copiedStation;
    if (panel.open) panel.close();
    restorePage();
    editingStation = null;
    copiedStation = null;
    deferredMode = false;
    editingDraftId = null;
    panel.removeAttribute('data-rfs-deferred');
    if (edit) { refreshConnection(); requestAnimationFrame(() => edit.returnToCart?.()); }
    else if (restoreFocus) returnFocus.focus({ preventScroll: true });
  }
  function focusStage() {
    if (!panel.open) return;
    scroll.scrollTop = 0;
    (currentStage === 'choice' ? q('#rs-choose h3') : q('#rs-service-title')).focus({ preventScroll: true });
  }
  const defaultPanelTitle = q('.rfs-panel-header h2').textContent;
  opener.addEventListener('click', () => openPanel());
  root.addEventListener('olouioo:refreshment:open', event => { if (!busy && !panel.open) openPanel(null, event.detail?.trigger || opener, null, event.detail?.defer ? drafts.find(item => item.id === event.detail.draftId) || {} : null); });
  root.addEventListener('olouioo:refreshment:edit', event => { if (!busy && !panel.open) openPanel(event.detail, event.detail?.trigger || opener); });
  root.addEventListener('olouioo:refreshment:copy', event => { if (!busy && !panel.open) openPanel(null, event.detail?.trigger || opener, event.detail); });
  q('[data-rfs-close]').addEventListener('click', () => { if (!busy) closePanel(); });
  panel.addEventListener('cancel', event => { event.preventDefault(); if (!busy) closePanel(); });
  panel.addEventListener('close', restorePage);
  panel.addEventListener('click', event => { if (event.target === panel && !busy) closePanel(); });
  document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) closePanel(false); });

  const holder = q('#rr-drinks');
  drinks.forEach((drink, index) => {
    const row = document.createElement('div');
    row.className = 'rr-drink';
    row.innerHTML = '<div class="rr-drink-top"><div class="rr-drink-media"><span class="rr-drink-number" aria-hidden="true"></span><img class="rr-drink-image" alt="" loading="lazy" width="240" height="340"></div><div class="rr-drink-content"><span class="rr-drink-series"></span><strong class="rr-drink-name"></strong><p class="rr-drink-description"></p><p class="rr-included-garnishes"></p><span class="rr-drink-price"></span><div class="rr-counter"><button type="button" data-minus>−</button><input type="number" min="0" max="1000" step="1" inputmode="numeric" enterkeyhint="done" autocomplete="off"><button type="button" data-plus>+</button></div></div></div>';
    row.querySelector('img').src = drink.image;
    row.querySelector('img').alt = drink.name;
    row.querySelector('.rr-drink-name').textContent = drink.name;
    row.querySelector('.rr-drink-number').textContent = String(index + 1).padStart(2, '0');
    row.querySelector('.rr-drink-series').textContent = tx('drink_series');
    row.querySelector('.rr-drink-description').textContent = drink.description;
    row.querySelector('.rr-included-garnishes').textContent = tx('included_garnishes') + ' ' + drink.garnishes.join(', ');
    const input = row.querySelector('input');
    input.value = drink.qty;
    input.setAttribute('aria-label', drink.name + ' quantity');
    function setQuantity(value, restoreFocus = true) { const wasSelected = drink.qty > 0; drink.qty = value; input.value = value; update(); if (!value && wasSelected && restoreFocus) row.querySelector('[data-plus]').focus({ preventScroll: true }); }
    row.querySelector('[data-minus]').addEventListener('click', () => setQuantity(drink.qty <= 10 ? 0 : drink.qty - 1));
    row.querySelector('[data-plus]').addEventListener('click', () => setQuantity(drink.qty === 0 ? 10 : Math.min(1000, (drink.qty || 0) + 1)));
    input.addEventListener('input', () => { drink.qty = Number(input.value); update(); });
    input.addEventListener('blur', () => {
      const value = Number(input.value);
      setQuantity(Number.isFinite(value) && value > 0 ? Math.min(1000, Math.max(10, Math.round(value))) : 0, false);
    });
    input.addEventListener('keydown', event => {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      input.blur();
      row.querySelector('[data-plus]').focus({ preventScroll: true });
    });
    holder.append(row);
    drink.row = row;
  });

  const guestCount = () => Number(q('#rr-guests').value);
  const waterValid = () => mode === 'drinks' || (Number.isInteger(guestCount()) && guestCount() >= 1 && guestCount() <= 110);
  const drinksValid = () => mode === 'water' || drinks.every(drink => Number.isInteger(drink.qty) && (drink.qty === 0 || drink.qty >= 10) && drink.qty <= 1000);
  const hasDrinks = () => drinks.some(drink => drink.qty > 0);
  function waterService(count) { return count <= 35 ? 'Water · up to 35 guests' : count >= 55 ? 'Water · 55–110 guests' : `Water · ${count} guests`; }
  function findVariant(service, finish) { return config.variants.find(variant => variant.option1 === service && variant.option2 === finish && variant.available); }
  function selectedLines() {
    const lines = [];
    if (mode !== 'drinks') lines.push({ variant: findVariant(waterService(guestCount()), q('#rs-water-finish').value), qty: 1, kind: 'water' });
    if (mode !== 'water') drinks.filter(drink => drink.qty > 0).forEach(drink => lines.push({ variant: findVariant(drink.name, q('#rs-drink-finish').value), qty: drink.qty, kind: 'drink', drink }));
    return lines;
  }
  function breakdown(lines) {
    const container = q('#rr-breakdown');
    container.replaceChildren();
    lines.forEach(line => {
      const row = document.createElement('div'), heading = document.createElement('div'), name = document.createElement('strong'), price = document.createElement('span'), detail = document.createElement('p');
      row.className = 'rr-breakdown-row';
      name.textContent = line.kind === 'water' ? 'Water · ' + guestCount() + ' guests' : line.qty + ' × ' + line.drink.name;
      price.textContent = money((line.variant?.price || 0) * line.qty / 100);
      detail.textContent = line.kind === 'water' ? q('#rr-water').value + ' · ' + q('#rs-water-finish').value : q('#rs-drink-finish').value + ' · ' + (line.drink.garnishes.join(' · '));
      heading.append(name, price);
      const photo = line.kind === 'water' ? config.stationImage : line.drink.image;
      if (photo) { const image = document.createElement('img'); image.className = 'rr-summary-image'; image.src = photo; image.alt = ''; image.loading = 'lazy'; image.width = 64; image.height = 76; row.append(image); }
      row.append(heading, detail);
      container.append(row);
    });
  }
  function update() {
    if (!busy) q('#rr-status').textContent = '';
    const valid = waterValid() && drinksValid(), lines = selectedLines();
    const available = lines.every(line => line.variant), ready = valid && (mode === 'water' || hasDrinks()) && available;
    q('#rr-add').disabled = busy || !waterValid() || (currentStage !== 'water' && !ready);
    q('#rr-error').hidden = valid && (currentStage !== 'review' || available);
    q('#rr-error').textContent = !available && currentStage === 'review' ? tx('js_9') : tx('js_3');
    drinks.forEach(drink => {
      drink.row.dataset.selected = String(drink.qty > 0);
      const minus = drink.row.querySelector('[data-minus]'), plus = drink.row.querySelector('[data-plus]');
      minus.disabled = busy || drink.qty <= 0;
      plus.disabled = busy || drink.qty >= 1000;
      minus.setAttribute('aria-label', (drink.qty <= 10 ? 'Remove ' : 'Remove one ') + drink.name);
      plus.setAttribute('aria-label', (drink.qty === 0 ? 'Add 10 ' : 'Add one ') + drink.name);
      drink.row.querySelector('.rr-drink-price').textContent = drink.qty > 0 ? drink.qty + tx('js_5') : tx('js_6');
    });
    root.querySelectorAll('[data-rfs-select]').forEach(group => {
      const select = q('#' + group.dataset.rfsSelect);
      group.querySelectorAll('[data-rfs-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.rfsValue === select.value)));
    });
    if (valid) { paintBookingReview(lines); breakdown(lines); }
    else q('#rr-total').textContent = '—';
    const matchCount = mode === 'drinks' ? linkedExperience.guests : guestCount();
    q('#rr-match').hidden = !Number.isInteger(matchCount) || matchCount < 10 || matchCount > 110;
    q('#rr-match').textContent = mode === 'drinks' ? tx('js_17') : tx('js_18');
    root.querySelectorAll('[data-range]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.range) === guestCount())));
    q('#rr-clear').textContent = mode === 'drinks' ? tx('js_19') : tx('js_20');
    q('#rr-clear').hidden = !hasDrinks();
    paintJourney();
    saveState();
  }
  function chooseService() { if (busy) return; currentStage = 'choice'; update(); focusStage(); }
  function goTo(stage) {
    if (busy) return;
    if (stage !== 'water' && !waterValid()) return;
    if (stage === 'review' && (!drinksValid() || (mode !== 'water' && !hasDrinks()))) return;
    currentStage = stage;
    update();
    focusStage();
  }
  function paintJourney() {
    panel.dataset.stage = currentStage;
    const choice = currentStage === 'choice', review = currentStage === 'review';
    q('#rs-choose').hidden = !choice;
    q('.rfs-panel-footer').hidden = choice;
    q('#rs-edit-head').hidden = choice;
    q('#rs-service-title').textContent = { water: tx('js_25'), drinks: tx('js_26'), both: tx('js_27') }[mode] || '';
    q('#rj-progress').hidden = choice;
    q('[data-rfs-step-status]').hidden = choice;
    q('.rr-water').hidden = currentStage !== 'water';
    q('.rr-mix').hidden = currentStage !== 'drinks';
    q('#rj-review').hidden = !review;
    q('[data-rfs-events]').hidden = !review;
    q('#rr-breakdown').hidden = !review;
    q('.rr-checkout').hidden = choice;
    q('#rj-back').hidden = choice;
    q('#rr-add span').textContent = currentStage === 'water' ? (mode === 'both' ? tx('js_43') : tx('js_44')) : currentStage === 'drinks' ? (hasDrinks() ? tx('js_45') : tx('js_46')) : (deferredMode ? tx('review_station_save') : editingStation ? tx('save_changes') : sourceService() ? tx(sourceInCart() ? 'add_station' : 'add_both') : tx('js_47'));
    q('#rj-completed-water').hidden = !(mode === 'both' && currentStage === 'drinks');
    q('#rj-water-text').textContent = tx('js_48') + q('#rr-guests').value + tx('js_49') + q('#rs-water-finish').value;
    const stages = mode === 'both' ? ['water', 'drinks', 'review'] : [mode === 'water' ? 'water' : 'drinks', 'review'];
    q('[data-rfs-step-status]').textContent = tx('step_status').replace('{current}', String(stages.indexOf(currentStage) + 1)).replace('{total}', String(stages.length));
    root.querySelectorAll('[data-service]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.service === mode)));
    root.querySelectorAll('[data-journey]').forEach(button => {
      const stage = button.dataset.journey;
      button.hidden = !stages.includes(stage);
      button.querySelector('[data-step-number]').textContent = String(stages.indexOf(stage) + 1);
      button.disabled = busy || (stage !== 'water' && !waterValid()) || (stage === 'review' && (!drinksValid() || (mode !== 'water' && !hasDrinks())));
      if (stage === currentStage) button.setAttribute('aria-current', 'step');
      else button.removeAttribute('aria-current');
    });
  }
  root.addEventListener('olouioo:duration-change', update);
  q('#rr-guests').addEventListener('input', update);
  q('#rr-guests').addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    q('#rr-guests').blur();
  });
  ['#rr-water', '#rs-water-finish', '#rs-drink-finish'].forEach(selector => q(selector).addEventListener('change', update));
  root.querySelectorAll('[data-rfs-value]').forEach(button => button.addEventListener('click', () => {
    if (busy) return;
    const select = q('#' + button.closest('[data-rfs-select]').dataset.rfsSelect);
    select.value = button.dataset.rfsValue;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }));
  root.querySelectorAll('[data-service]').forEach(button => button.addEventListener('click', () => {
    if (busy) return;
    mode = button.dataset.service;
    currentStage = mode === 'drinks' ? 'drinks' : 'water';
    update();
    focusStage();
  }));
  q('#rs-change').addEventListener('click', chooseService);
  root.querySelectorAll('[data-journey]').forEach(button => button.addEventListener('click', () => goTo(button.dataset.journey)));
  q('#rj-edit-water').addEventListener('click', () => goTo('water'));
  q('#rj-back').addEventListener('click', () => {
    if (currentStage === 'review') goTo(mode === 'water' ? 'water' : 'drinks');
    else if (currentStage === 'drinks' && mode === 'both') goTo('water');
    else chooseService();
  });
  q('#rr-add').addEventListener('click', () => {
    if (currentStage === 'water') goTo(mode === 'both' ? 'drinks' : 'review');
    else if (currentStage === 'drinks') goTo('review');
    else addStation().catch(showAddError);
  });
  q('#rr-match').addEventListener('click', () => {
    const count = mode === 'drinks' ? linkedExperience.guests : guestCount();
    if (!Number.isInteger(count) || count < 1 || count > 110) return;
    let selected = drinks.filter(drink => drink.qty > 0);
    if (!selected.length) selected = [drinks[0]];
    if (count < selected.length * 10) { q('#rr-error').hidden = false; q('#rr-error').textContent = tx('js_21') + count + tx('js_22'); return; }
    drinks.forEach(drink => { drink.qty = 0; });
    selected.forEach((drink, index) => { drink.qty = Math.floor(count / selected.length) + (index < count % selected.length ? 1 : 0); });
    drinks.forEach(drink => { drink.row.querySelector('.rr-counter input').value = drink.qty; });
    update();
  });
  q('#rr-clear').addEventListener('click', () => {
    drinks.forEach(drink => { drink.qty = 0; drink.row.querySelector('.rr-counter input').value = 0; });
    if (mode === 'both') { mode = 'water'; goTo('water'); }
    else update();
  });

  function syncExperience() {
    const hasCount = Number.isInteger(linkedExperience.guests) && linkedExperience.guests > 0 && linkedExperience.guests <= 110;
    q('[data-rfs-context]').hidden = !linkedExperience.title;
    q('#rc-experience-title').textContent = linkedExperience.title + (linkedExperience.summary ? ' · ' + linkedExperience.summary : hasCount ? ' · ' + linkedExperience.guests + tx('js_35') : '');
    q('#rl-edit-count').hidden = !hasCount;
    q('.rfs-guest-field').hidden = matched && hasCount;
    if (matched && hasCount) {
      q('#rr-guests').value = linkedExperience.guests;
      q('#rr-guests').readOnly = true;
      q('#rl-presets').hidden = true;
      q('#rl-match-caption').textContent = tx('js_36') + linkedExperience.guests + tx('js_37') + linkedExperience.title + tx('js_38');
      q('#rl-edit-count').textContent = tx('js_39');
    } else {
      q('#rr-guests').readOnly = false;
      q('#rl-presets').hidden = false;
      q('#rl-match-caption').textContent = linkedExperience.guests > 110 ? tx('water_limit').replace('{count}',linkedExperience.guests) : hasCount ? tx('js_40') : tx('js_41');
      q('#rl-edit-count').textContent = tx('js_42');
    }
    update();
  }
  function sourceSelection() {
    const selected = sourceService();
    if (selected) return selected;
    if (!sourceScope) return null;
    const picked = [...sourceScope.querySelectorAll('variant-picker input:checked,variant-picker select,signature-menu-picker input:checked')];
    const choices = picked.map(input => ({ label: input.closest('fieldset,.variant-option')?.querySelector('legend,.variant-option__label-text')?.textContent || input.name, value: input.value }));
    const qty = Math.max(1, Number(sourceScope.querySelector('.buy-buttons-block [name=quantity]')?.value) || 1);
    const count = Number(choices.find(choice => /guest/i.test(choice.label))?.value.match(/\d+/)?.[0]) || null;
    return { title:config.sourceTitle, guests:config.sourceHandle === 'la-table' ? qty * 8 : config.sourceHandle === 'la-coupe-welcome-toast-table' ? null : count ? count * qty : null, handle:config.sourceHandle };
  }
  function syncSourceDefaults() {
    const selected = sourceService();
    if (!selected || editingStation || copiedStation) return;
    if (selected.guests > 110 && matched) q('#rr-guests').value = '';
    const duration = q('[data-hire-duration]');
    if (duration) window.OlouiooDuration?.setDuration(root, selected.hours, window.OlouiooDuration.mode(sourceOwner()));
    if (selected.finish) ['#rs-water-finish','#rs-drink-finish'].forEach(selector => { q(selector).value = selected.finish; });
    const source = sourceOwner();
    for (const selector of ['[data-event-date]','[data-start-time]']) {
      const value = source?.querySelector(selector)?.value;
      if (value && q(selector)) q(selector).value = value;
    }
    q('[data-start-time]')?.dispatchEvent(new Event('input', {bubbles:true}));
    update();
  }
  function sourceInCart(preparedItems = null) {
    const selected = sourceService(), owner = sourceOwner();
    if (!selected || !owner || !cartSnapshot) return false;
    const form = owner.querySelector('form');
    if (!form) return false;
    const data = new FormData(form), properties = preparedItems?.[0]?.properties || {};
    if (!preparedItems) {
      for (const [name, value] of data.entries()) {
        const key = name.match(/^properties\[(.+)\]$/)?.[1];
        if (key && value && (!key.startsWith('_') || key === '_olouioo_duration_hours')) properties[key] = String(value);
      }
      sourceScope.querySelectorAll('[data-table-property]:checked').forEach(input => { properties[input.dataset.tableProperty] = input.value; });
      properties._olouioo_duration_hours = String(selected.hours);
    }
    if (!properties['Event date'] || !properties['Start time']) return false;
    const derived = ['Setup date','Setup start','Finish time','Pack-down start','Pack-down complete','Event duration','Hire duration','Setup and pack-down allowance'];
    return cartSnapshot.items.find(item => String(item.product_id) === String(config.sourceId) && Number(item.variant_id) === selected.id && item.quantity === selected.quantity && Object.entries(properties).every(([key,value]) => key.startsWith('_') && key !== '_olouioo_duration_hours' || derived.includes(key) || String(item.properties?.[key] ?? (key === '_olouioo_duration_hours' ? 3 : '')) === String(value))) || false;
  }
  function paintBookingReview(lines) {
    const stationTotal = lines.reduce((sum,line) => sum + (line.variant?.price || 0) * line.qty,0) + (window.OlouiooDuration?.cost(root,lines) || 0);
    const selected = !deferredMode && !editingStation && sourceService(), inCart = !!sourceInCart();
    const combined = currentStage === 'review' && selected;
    const container = q('[data-rfs-booking-review]');
    if (container) {
      container.hidden = !selected;
      q('[data-rfs-review-title]').textContent = selected ? tx('review_booking') : reviewTitle;
      q('[data-rfs-review-note]').textContent = deferredMode ? tx('review_station_draft_note') : selected ? tx('station_review_note') : reviewNote;
      if (selected) {
        q('[data-rfs-source-title]').textContent = selected.title;
        q('[data-rfs-source-details]').textContent = [selected.summary,selected.duration].filter(Boolean).join(' · ');
        const options = [...sourceScope.querySelectorAll('variant-picker input:checked,variant-picker select,signature-menu-picker input:checked,[data-table-property]:checked')].filter(input => !input.closest('[hidden]')).map(input => {
          const label = input.closest('fieldset,.variant-option')?.querySelector('legend,.variant-option__label-text')?.textContent.trim().replace(/\?$/, '');
          const value = input.dataset.displayValue || input.value;
          return value ? (label ? label + ': ' : '') + value : '';
        }).filter(Boolean);
        q('[data-rfs-source-options]').textContent = [...new Set(options)].join(' · ');
        q('[data-rfs-source-added]').hidden = !inCart;
        q('[data-rfs-source-price]').textContent = money(selected.total / 100);
        q('[data-rfs-station-price]').textContent = money(stationTotal / 100);
        q('[data-rfs-combined-note]').hidden = inCart;
      }
    }
    if (q('[data-rfs-total-label]')) q('[data-rfs-total-label]').textContent = tx(combined && !inCart ? 'combined_total' : 'station_subtotal');
    q('#rr-total').textContent = money((stationTotal + (combined && !inCart ? selected.total : 0)) / 100);
  }
  function refreshConnection() {
    if (editingStation || copiedStation) return;
    let next = sourceSelection();
    if (!next) {
      const items = (cartSnapshot?.items || []).filter(item => String(item.product_id) !== String(config.stationId));
      const serviceHandles = ['la-table','le-chariot','l-or','reveil','noir','lumiere','la-table-signature-collection','le-chariot-signature-collection','le-jardin-garden-refreshment-table','la-coupe-welcome-toast-table','le-botanique-interactive-botanical-bar','olouioo-signature-coupe-tower-setup-upgrade'];
      const item = items.find(item => serviceHandles.includes(item.handle));
      if (item) {
        const perUnit = item.handle === 'la-table' ? 8 : Number(item.variant_title?.match(/(?:Up to )?(\d+) guests/i)?.[1]) || null;
        next = { title:item.product_title || item.title, guests:item.handle === 'la-coupe-welcome-toast-table' ? null : perUnit ? perUnit * item.quantity : null };
      }
    }
    linkedExperience = next || { title: '', guests: null };
    syncExperience();
  }
  async function readCart() {
    try {
      const response = await fetch(config.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      cartSnapshot = await response.json();
      document.dispatchEvent(new CustomEvent('olouioo:refreshment:cart', { detail: { sourceId: config.sourceId, stationId: config.stationId, items: cartSnapshot.items } }));
      refreshConnection();
    } catch {}
  }
  let sourceQueued = false;
  function sourceChanged() { if (sourceQueued) return; sourceQueued = true; requestAnimationFrame(() => { sourceQueued = false; refreshConnection(); }); }
  sourceScope?.addEventListener('change', sourceChanged);
  sourceScope?.addEventListener('input', sourceChanged);
  sourceScope?.addEventListener('quantity-selector:update', sourceChanged);
  sourceScope?.addEventListener('olouioo:service-variant', sourceChanged);
  document.addEventListener('variant:update', sourceChanged);
  document.addEventListener('olouioo:service-state', sourceChanged);
  document.addEventListener('cart:update', () => { if (!busy) readCart(); });
  q('#rl-edit-count').addEventListener('click', () => {
    q('#rr-guests').blur();
    matched = !matched;
    syncExperience();
    if (!matched) requestAnimationFrame(() => revealControl(q('#rr-guests')));
  });
  root.querySelectorAll('[data-range]').forEach(button => button.addEventListener('click', () => {
    q('#rr-guests').value = button.dataset.range;
    q('#rr-guests').blur();
    update();
  }));

  function saveState() {
    if (deferredMode || editingStation || copiedStation) return;
    try { sessionStorage.setItem('olouioo:refreshment:' + config.sourceHandle, JSON.stringify({ mode, matched, guests: q('#rr-guests').value, water: q('#rr-water').value, waterFinish: q('#rs-water-finish').value, drinkFinish: q('#rs-drink-finish').value })); } catch {}
  }
  function restoreState() {
    try {
      const state = JSON.parse(sessionStorage.getItem('olouioo:refreshment:' + config.sourceHandle) || 'null');
      if (!state) return;
      if (['water', 'drinks', 'both'].includes(state.mode)) mode = state.mode;
      if (typeof state.matched === 'boolean') matched = state.matched;
      if (Number(state.guests) >= 1 && Number(state.guests) <= 110) q('#rr-guests').value = state.guests;
      for (const [key, selector] of [['water', '#rr-water'], ['waterFinish', '#rs-water-finish'], ['drinkFinish', '#rs-drink-finish']]) {
        if (state[key] && [...q(selector).options].some(option => option.value === state[key])) q(selector).value = state[key];
      }

    } catch {}
  }

  function restoreStation(edit) {
    const water = edit.items.find(item => config.variants.find(variant => Number(variant.id) === item.variant_id)?.option1.includes('Water'));
    const drinkItems = edit.items.filter(item => item !== water);
    mode = water ? (drinkItems.length ? 'both' : 'water') : 'drinks';
    currentStage = water ? 'water' : 'drinks';
    matched = false;
    const properties = edit.items[0].properties || {};
    const native = window.OlouiooService?.read(sourceOwner());
    const selected = native && String(native.productId) === properties._olouioo_source_product && String(native.id) === properties._olouioo_source_variant && String(native.quantity) === properties._olouioo_source_quantity ? native : null;
    const source = edit.source;
    const perUnit = source?.handle === 'la-table' ? 8 : source && !['la-coupe-welcome-toast-table','olouioo-signature-coupe-tower-setup-upgrade'].includes(source.handle) ? Number(source.variant_title?.match(/(?:Up to )?(\d+) guests/i)?.[1]) || null : null;
    linkedExperience = { title: properties['Linked experience'] || '', guests:selected?.guests || (perUnit ? perUnit * source.quantity : null), summary:selected?.summary || '' };
    if (water) {
      const variant = config.variants.find(variant => Number(variant.id) === water.variant_id);
      q('#rr-guests').value = water.properties['Water-service guests'] || variant.option1.match(/\d+/)?.[0] || 35;
      q('#rr-water').value = water.properties['Water style'] || 'Botanical-infused water';
      q('#rs-water-finish').value = variant.option2;
    }
    drinks.forEach(drink => {
      const saved = drinkItems.filter(item => config.variants.find(variant => Number(variant.id) === item.variant_id)?.option1 === drink.name);
      drink.qty = saved.reduce((total, item) => total + item.quantity, 0);
      drink.row.querySelector('.rr-counter input').value = drink.qty;
    });
    if (drinkItems.length) q('#rs-drink-finish').value = config.variants.find(variant => Number(variant.id) === drinkItems[0].variant_id)?.option2 || 'Premium acrylic';
    for (const input of q('[data-rfs-event-form]').elements) {
      const key = input.name?.match(/^properties\[(.+)\]$/)?.[1];
      if (key && properties[key] != null) input.value = properties[key];
    }
    const durationField = q('[data-hire-duration]');
    if (durationField) window.OlouiooDuration?.setDuration(root, Number(properties._olouioo_duration_hours || 3), properties._olouioo_duration_mode || window.OlouiooDuration.mode(root), true);
    q('[data-start-time]')?.dispatchEvent(new Event('input', { bubbles:true }));
    q('.rfs-panel-header h2').textContent = tx('edit_title');
    syncExperience();
  }
  async function cartRequest(endpoint, payload) {
    const response = await fetch(config.root + endpoint, { method: payload ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, cache: 'no-store', ...(payload ? { body: JSON.stringify(payload) } : {}) });
    const result = await response.json();
    if (!response.ok || result.status || result.errors) throw new Error(typeof result.description === 'string' ? result.description : tx('update_error'));
    return result;
  }
  async function replaceStation(edit, items, sections) {
    const belongsToOld = item => (String(item.product_id) === String(config.stationId) || item.properties?._olouioo_duration_component === 'true') && (item.properties?._olouioo_refreshment_group === edit.group || (!item.properties?._olouioo_refreshment_group && edit.items.some(previous => previous.key === item.key)));
    const current = await cartRequest('cart.js');
    if (!current.items.some(belongsToOld)) throw new Error(tx('station_missing'));
    const group = items[0].properties._olouioo_refreshment_group;
    const belongsToNew = item => (String(item.product_id) === String(config.stationId) || item.properties?._olouioo_duration_component === 'true') && item.properties?._olouioo_refreshment_group === group;
    try {
      await cartRequest('cart/add.js', { items });
      const fresh = await cartRequest('cart.js');
      const old = fresh.items.filter(belongsToOld);
      if (!old.length) throw new Error(tx('station_missing'));
      return await cartRequest('cart/update.js', { updates: Object.fromEntries(old.map(item => [item.key, 0])), sections, sections_url: location.pathname });
    } catch (failure) {
      const latest = await cartRequest('cart.js').catch(() => null);
      if (!latest) throw new Error(tx('update_recovery_error'));
      if (!latest.items.some(belongsToOld) && latest.items.some(belongsToNew)) {
        return await cartRequest('cart/update.js', { updates: {}, sections, sections_url: location.pathname });
      }
      const added = latest.items.filter(belongsToNew);
      if (added.length) {
        try { await cartRequest('cart/update.js', { updates: Object.fromEntries(added.map(item => [item.key, 0])) }); }
        catch { throw new Error(tx('update_recovery_error')); }
      }
      throw failure;
    }
  }

  async function addBooking(items, sections) {
    if (!pendingSubmission) {
      const group = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(16).slice(2);
      items.forEach(item => { item.properties._olouioo_submission_group = group; });
      pendingSubmission = {items,sections,group};
      try {
        const result = await cartRequest('cart/add.js', {items,sections,sections_url:location.pathname});
        pendingSubmission = null;
        return result;
      } catch (error) { pendingSubmission.error = error; }
    }
    const pending = pendingSubmission;
    const cart = await cartRequest('cart.js').catch(() => null);
    if (!cart) throw new Error(tx('recovery_error'));
    const saved = cart.items.filter(item => item.properties?._olouioo_submission_group === pending.group);
    const complete = saved.length === pending.items.length && pending.items.every(expected => saved.some(item => Number(item.variant_id) === expected.id && item.quantity === expected.quantity && item.properties?._olouioo_hire_group === expected.properties._olouioo_hire_group));
    if (complete) {
      const result = await cartRequest('cart/update.js', {updates:{},sections:pending.sections,sections_url:location.pathname});
      pendingSubmission = null;
      return result;
    }
    if (saved.length) {
      try { await cartRequest('cart/update.js', {updates:Object.fromEntries(saved.map(item => [item.key,0]))}); }
      catch { throw new Error(tx('recovery_error')); }
    }
    pendingSubmission = null;
    throw pending.error || new Error(tx('partial_error'));
  }

  function showAddError(error) { q('#rr-error').hidden = false; q('#rr-error').textContent = error.message || tx('js_50'); }
  async function addStation() {
    if (busy) return;
    update();
    if (q('#rr-add').disabled) return;
    if (deferredMode) { saveDraft(); return; }
    const form = q('[data-rfs-event-form]'), booking = form?.querySelector('event-booking-fields');
    if (!form || !booking || !window.OlouiooEvents) throw new Error(tx('js_51'));
    if (!form.reportValidity()) return;
    const eventData = new FormData(form);
    const edit = editingStation;
    busy = true;
    root.setAttribute('aria-busy', 'true');
    q('#rr-add').setAttribute('aria-busy', 'true');
    const states = [...root.querySelectorAll('button,input,select')].map(input => [input, input.disabled]);
    states.forEach(([input]) => { input.disabled = true; });
    let announcement, succeeded = false, includedService = false;
    const owner = !edit && !copiedStation ? sourceOwner() : null;
    const ownerBusy = owner?.getAttribute('aria-busy');
    if (ownerBusy === 'true') { busy = false; root.removeAttribute('aria-busy'); q('#rr-add').removeAttribute('aria-busy'); states.forEach(([input,disabled]) => { input.disabled = disabled; }); return; }
    owner?.setAttribute('aria-busy','true');
    try {
      let sourceItems = null;
      if (!edit && sourceService()) {
        const {prepareProductForm} = await import('@theme/variant-selection');
        const prepared = await prepareProductForm(owner);
        if (!prepared) return;
        sourceItems = window.OlouiooDuration?.productItems(owner,prepared.data);
        if (!sourceItems) throw new Error(tx('js_50'));
        cartSnapshot = await cartRequest('cart.js');
        includedService = !sourceInCart(sourceItems);
      }
      await window.OlouiooEvents.prepare(booking, eventData);
      const eventProps = {};
      for (const [name, value] of eventData.entries()) { const match = name.match(/^properties\[(.+)\]$/); if (match) eventProps[match[1]] = value; }
      const group = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : String(Date.now());
      let items = selectedLines().map(line => {
        if (!line.variant || !Number.isInteger(line.qty) || line.qty < 1 || (line.kind === 'drink' && line.qty < 10)) throw new Error(tx('js_52'));
        const properties = { ...eventProps, '_olouioo_refreshment': line.kind, '_olouioo_refreshment_group': group, Station: 'Olouioo Refreshment Station', 'Station service': mode === 'both' ? 'Water & drinks' : mode === 'water' ? 'Water' : 'Drinks', Drinkware: line.variant.option2 };
        if (linkedExperience.title) properties['Linked experience'] = linkedExperience.title;
        const source = !edit && sourceService();
        if (source) Object.assign(properties, {_olouioo_source_product:String(source.productId),_olouioo_source_variant:String(source.id),_olouioo_source_quantity:String(source.quantity)});
        else if (edit || copiedStation) for (const key of ['_olouioo_source_product','_olouioo_source_variant','_olouioo_source_quantity']) { const value = (edit || copiedStation).items[0].properties?.[key]; if (value) properties[key] = value; }
        if (line.kind === 'water') { properties['Water-service guests'] = String(guestCount()); properties['Water style'] = q('#rr-water').value; }
        else properties.Garnishes = line.drink.garnishes.join(', ');
        return { id: Number(line.variant.id), quantity: line.qty, properties };
      });
      if (q('[data-hire-options]') && !window.OlouiooDuration) throw new Error(tx('js_50'));
      items = window.OlouiooDuration?.extend(root, items, group, true) || items;
      if (includedService) items = [...sourceItems,...items];
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(element => element.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const events = await import('@theme/standard-cart-events');
      announcement = events.announceCartLinesUpdate(root, { action: edit ? 'update' : 'add', context: edit ? 'cart' : 'product', lines: items.map(item => ({ merchandiseId: String(item.id), quantity: item.quantity })) });
      if (edit) {
        const cart = await replaceStation(edit, items, sections);
        succeeded = true;
        const { CartUpdateEvent } = await import('@theme/events');
        document.dispatchEvent(new CartUpdateEvent({}, String(config.stationId), { source: 'refreshment-station-edit', items: cart.items, itemCount: cart.item_count, sections: cart.sections, autoOpenDrawer: false }));
        events.settleWithCart(announcement, cart, { source: 'refreshment-station-edit', sections: cart.sections });
        closePanel(false);
        return;
      }
      const result = await addBooking(items,sections);
      succeeded = true;
      q('[data-rfs-cart-link]').hidden = false;
      // Release the top layer before the native cart drawer opens.
      closePanel(false);
      const { CartAddEvent } = await import('@theme/events');
      document.dispatchEvent(new CartAddEvent({}, String(config.stationId), { source:sourceService() ? 'service-station-booking' : 'refreshment-station', productId:String(sourceService() ? config.sourceId : config.stationId), sections:result.sections }));
      await events.settleWithFetchedCart(announcement, { source:sourceService() ? 'service-station-booking' : 'refreshment-station', sourceId:root.id || 'refreshment-station', productId:String(sourceService() ? config.sourceId : config.stationId), sections:result.sections });
    } catch (error) { announcement?.reject(error); if (!succeeded) throw error; }
    finally {
      busy = false;
      if (owner) { if (ownerBusy == null) owner.removeAttribute('aria-busy'); else owner.setAttribute('aria-busy',ownerBusy); }
      root.removeAttribute('aria-busy');
      q('#rr-add').removeAttribute('aria-busy');
      states.forEach(([input, disabled]) => { input.disabled = disabled; });
      update();
      if (succeeded) q('#rr-status').textContent = tx(edit ? 'updated' : 'js_54');
      if (succeeded) readCart();
    }
  }

  function snapshotDraft() {
    return { mode, guests:guestCount(), water:q('#rr-water').value, waterFinish:q('#rs-water-finish').value, drinkFinish:q('#rs-drink-finish').value, drinks:drinks.map(drink => drink.qty) };
  }
  function restoreDraftState(state) {
    mode = state.mode;
    matched = false;
    currentStage = 'review';
    q('#rr-guests').value = state.guests;
    q('#rr-water').value = state.water;
    q('#rs-water-finish').value = state.waterFinish;
    q('#rs-drink-finish').value = state.drinkFinish;
    drinks.forEach((drink,index) => { drink.qty = state.drinks[index] || 0; drink.row.querySelector('.rr-counter input').value = drink.qty; });
  }
  function draftLines(state) {
    const lines = [];
    if (state.mode !== 'drinks') lines.push({variant:findVariant(waterService(state.guests),state.waterFinish),qty:1,kind:'water'});
    if (state.mode !== 'water') drinks.forEach((drink,index) => { const qty = state.drinks[index] || 0; if(qty) lines.push({variant:findVariant(drink.name,state.drinkFinish),qty,kind:'drink',drink}); });
    if (!['water','drinks','both'].includes(state.mode) || !lines.length || lines.some(line => !line.variant || !Number.isInteger(line.qty) || line.qty < (line.kind === 'drink' ? 10 : 1) || line.qty > 1000) || state.mode !== 'drinks' && (!Number.isInteger(state.guests) || state.guests < 1 || state.guests > 110)) throw new Error(tx('js_52'));
    return lines;
  }
  function alignDraftDuration() {
    const selected = sourceService(), duration = q('[data-hire-duration]');
    if (!selected || !duration) return;
    window.OlouiooDuration?.setDuration(root, selected.hours, window.OlouiooDuration.mode(sourceOwner()));
    const option = [...duration.options].find(item => Number(item.value) === selected.hours && !item.disabled);
    if (!option) throw new Error(tx('js_50'));
    duration.value = option.value;
  }
  function describeDrafts() {
    alignDraftDuration();
    return drafts.map(draft => {
      const lines = draftLines(draft.state);
      const descriptions = lines.map(line => line.kind === 'water' ? tx('review_station_water').replace('{count}',draft.state.guests).replace('{style}',draft.state.water).replace('{finish}',draft.state.waterFinish) : tx('review_station_drink').replace('{count}',line.qty).replace('{drink}',line.drink.name).replace('{finish}',draft.state.drinkFinish));
      return {id:draft.id,included:draft.included!==false,description:[config.sourceHandle === 'l-or' ? config.barRefreshments : '',...descriptions].filter(Boolean).join(' · '),total:lines.reduce((sum,line) => sum + line.variant.price * line.qty,0) + (window.OlouiooDuration?.cost(root,lines) || 0)};
    });
  }
  function emitDrafts() {
    document.dispatchEvent(new CustomEvent('olouioo:refreshment:draft',{detail:{sourceId:config.sourceId,drafts:describeDrafts()}}));
  }
  function saveDraft() {
    const state = snapshotDraft();
    draftLines(state);
    const id = editingDraftId || (typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(16).slice(2));
    const index = drafts.findIndex(item => item.id === id);
    const draft = {id,state,included:index===-1 || drafts[index].included!==false};
    if(index === -1) drafts.push(draft); else drafts[index] = draft;
    closePanel();
    emitDrafts();
  }
  function prepareDraftItems(eventProps) {
    alignDraftDuration();
    const selected = sourceService();
    if (!selected) throw new Error(tx('js_50'));
    return drafts.filter(draft=>draft.included!==false).flatMap(draft => {
      const group = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(16).slice(2);
      const items = draftLines(draft.state).map(line => {
        const properties = {...eventProps,_olouioo_refreshment:line.kind,_olouioo_refreshment_group:group,Station:'Olouioo Refreshment Station','Refreshment setup':config.sourceHandle === 'l-or' ? config.barPlacement : config.tablePlacement,'Station service':draft.state.mode === 'both' ? 'Water & drinks' : draft.state.mode === 'water' ? 'Water' : 'Drinks',Drinkware:line.variant.option2,'Linked experience':selected.title,_olouioo_source_product:String(selected.productId),_olouioo_source_variant:String(selected.id),_olouioo_source_quantity:String(selected.quantity)};
        if(line.kind === 'water') Object.assign(properties,{'Water-service guests':String(draft.state.guests),'Water style':draft.state.water});
        else properties.Garnishes = line.drink.garnishes.join(', ');
        return {id:Number(line.variant.id),quantity:line.qty,properties};
      });
      if(q('[data-hire-options]') && !window.OlouiooDuration) throw new Error(tx('js_50'));
      return window.OlouiooDuration?.extend(root,items,group,true) || items;
    });
  }
  async function submitReview(includeStation = false) {
    const owner = sourceOwner();
    if(busy || !owner || owner.getAttribute('aria-busy') === 'true') return null;
    if(includeStation && !drafts.length) throw new Error(tx('review_station_choose_required'));
    busy = true;
    root.setAttribute('aria-busy','true');
    owner.setAttribute('aria-busy','true');
    let announcement, succeeded=false;
    try {
      const {prepareProductForm} = await import('@theme/variant-selection');
      const prepared = await prepareProductForm(owner);
      if(!prepared) return null;
      if(!window.OlouiooDuration) throw new Error(tx('js_50'));
      let items = window.OlouiooDuration.productItems(owner,prepared.data);
      if(!items?.length) throw new Error(tx('js_50'));
      if(includeStation) {
        const keys = new Set([...q('[data-rfs-event-form]').elements].map(input => input.name?.match(/^properties\[(.+)\]$/)?.[1]).filter(Boolean));
        const eventProps = Object.fromEntries(Object.entries(items[0].properties).filter(([key]) => keys.has(key)));
        items = [...items,...prepareDraftItems(eventProps)];
      }
      const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(element => element.dataset.sectionId).filter(Boolean))].slice(0,5);
      const events = await import('@theme/standard-cart-events');
      announcement = events.announceCartLinesUpdate(root,{action:'add',context:'product',lines:items.map(item=>({merchandiseId:String(item.id),quantity:item.quantity}))});
      const result = await addBooking(items,sections);
      succeeded=true;
      const {CartAddEvent} = await import('@theme/events');
      document.dispatchEvent(new CartAddEvent({},String(prepared.variant.id),{source:'service-station-booking',productId:String(config.sourceId),sections:result.sections,autoOpenDrawer:false}));
      await events.settleWithFetchedCart(announcement,{source:'service-station-booking',sourceId:root.id || 'service-review',productId:String(config.sourceId),sections:result.sections,autoOpenDrawer:false});
      const cart = await cartRequest('cart.js').catch(()=>null);
      return {cart};
    } catch(error) { announcement?.reject(error); if(succeeded) return {cart:null}; throw error; }
    finally {busy=false;root.removeAttribute('aria-busy');owner.removeAttribute('aria-busy');update();}
  }
  root.olouiooReview = {
    getDrafts:describeDrafts,
    setDraftIncluded(id,included) {const draft=drafts.find(item=>item.id===id);if(draft){draft.included=Boolean(included);emitDrafts();}},
    removeDraft(id) {const index=drafts.findIndex(item=>item.id===id);if(index!==-1)drafts.splice(index,1);emitDrafts();},
    prepareDraftItems,
    submit:submitReview
  };

  restoreState();
  refreshConnection();
  root.dataset.ready = 'true';
  opener.disabled = false;
  readCart();
}
window.OlouiooRefreshment = { boot: () => bootRefreshment() };
function bootRefreshment() { document.querySelectorAll('[data-rfs-root]').forEach(initRefreshment); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootRefreshment);
else bootRefreshment();
document.addEventListener('shopify:section:load', bootRefreshment);






